import {APIService} from "../../common/APIService";
import {Color} from "../../dto/Color";

export class ColorService extends APIService {
  public async browse() {
    const json = await this.getJson<{ data: object[] }>(`colors`)
    return json.data.map(Color.fromJson)
  }

  public async add(name: string, enabled: boolean, color: string) {
    const json = await this.postJson<{ data: object }>(`colors`, {
      name: name,
      enabled: enabled,
      color: color
    })
    return Color.fromJson(json)
  }

  public async update(id: string, name: string, enabled: boolean, color: string) {
    const json = await this.putJson<{ data: object }>(`colors/${id}`, {
      name: name,
      enabled: enabled,
      color: color
    })
    return Color.fromJson(json)
  }
}